import { render, staticRenderFns } from "./StudentPasswordReset.vue?vue&type=template&id=d6a25986&scoped=true&lang=pug&"
import script from "./StudentPasswordReset.vue?vue&type=script&lang=ts&"
export * from "./StudentPasswordReset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a25986",
  null
  
)

export default component.exports